import React from 'react';

const Privacy = () => {
  return (
    <div className="privacy-policy" style={{
      padding: '40px',
      maxWidth: '800px',
      margin: '0 auto',
      backgroundColor: '#ffffff',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      lineHeight: '1.6'
    }}>
      <h1 style={{ 
        color: '#1890ff', 
        marginBottom: '24px',
        textAlign: 'center',
        fontSize: '28px'
      }}>
        Kebijakan Privasi
      </h1>
      <p style={{ marginBottom: '32px', textAlign: 'center', color: '#666' }}>
        <strong>Terakhir diperbarui:</strong> 21 Juni 2025
      </p>

      <p style={{ marginBottom: '24px', textAlign: 'justify' }}>
        Aplikasi ini ("Aplikasi") dikembangkan untuk keperluan kegiatan sekolah, yang mencakup pengelolaan data siswa, pelajaran yang diikuti, serta informasi dan proses pembayaran sekolah.
      </p>

      <h2 style={{ 
        color: '#1890ff', 
        marginTop: '32px', 
        marginBottom: '16px',
        fontSize: '20px'
      }}>
        1. Informasi yang Kami Kumpulkan
      </h2>
      <p style={{ marginBottom: '12px', textAlign: 'justify' }}>
        Kami dapat mengumpulkan informasi berikut dari pengguna aplikasi:
      </p>
      <ul style={{ 
        paddingLeft: '24px', 
        marginBottom: '24px',
        lineHeight: '1.8'
      }}>
        <li style={{ marginBottom: '4px' }}>Nama lengkap siswa</li>
        <li style={{ marginBottom: '4px' }}>NIS/NISN atau nomor identitas siswa lainnya</li>
        <li style={{ marginBottom: '4px' }}>Kelas dan mata pelajaran yang diikuti</li>
        <li style={{ marginBottom: '4px' }}>Riwayat kehadiran dan nilai akademik</li>
        <li style={{ marginBottom: '4px' }}>Informasi pembayaran (jumlah, tanggal, metode)</li>
        <li style={{ marginBottom: '4px' }}>Informasi orang tua atau wali (nama, nomor telepon, alamat email)</li>
      </ul>

      <h2 style={{ 
        color: '#1890ff', 
        marginTop: '32px', 
        marginBottom: '16px',
        fontSize: '20px'
      }}>
        2. Penggunaan Informasi
      </h2>
      <p style={{ marginBottom: '12px', textAlign: 'justify' }}>
        Informasi yang dikumpulkan akan digunakan untuk:
      </p>
      <ul style={{ 
        paddingLeft: '24px', 
        marginBottom: '24px',
        lineHeight: '1.8'
      }}>
        <li style={{ marginBottom: '4px' }}>Mengelola data akademik dan administratif siswa</li>
        <li style={{ marginBottom: '4px' }}>Mengatur jadwal pelajaran dan kegiatan sekolah</li>
        <li style={{ marginBottom: '4px' }}>Menyediakan informasi kepada siswa dan orang tua</li>
        <li style={{ marginBottom: '4px' }}>Memproses dan mencatat pembayaran sekolah</li>
        <li style={{ marginBottom: '4px' }}>Meningkatkan layanan dan fitur aplikasi</li>
      </ul>

      <h2 style={{ 
        color: '#1890ff', 
        marginTop: '32px', 
        marginBottom: '16px',
        fontSize: '20px'
      }}>
        3. Pembagian Informasi
      </h2>
      <p style={{ marginBottom: '12px', textAlign: 'justify' }}>
        Kami tidak akan membagikan informasi pribadi pengguna kepada pihak ketiga, kecuali:
      </p>
      <ul style={{ 
        paddingLeft: '24px', 
        marginBottom: '24px',
        lineHeight: '1.8'
      }}>
        <li style={{ marginBottom: '4px' }}>Dengan persetujuan pengguna</li>
        <li style={{ marginBottom: '4px' }}>Sesuai dengan peraturan hukum yang berlaku</li>
        <li style={{ marginBottom: '4px' }}>Kepada pihak sekolah atau lembaga pendidikan terkait</li>
      </ul>

      <h2 style={{ 
        color: '#1890ff', 
        marginTop: '32px', 
        marginBottom: '16px',
        fontSize: '20px'
      }}>
        4. Keamanan Data
      </h2>
      <p style={{ marginBottom: '24px', textAlign: 'justify' }}>
        Kami berkomitmen untuk melindungi data pribadi pengguna dengan langkah-langkah keamanan teknis dan administratif yang sesuai agar data tidak diakses, diubah, atau dihapus tanpa izin.
      </p>

      <h2 style={{ 
        color: '#1890ff', 
        marginTop: '32px', 
        marginBottom: '16px',
        fontSize: '20px'
      }}>
        5. Hak Pengguna
      </h2>
      <p style={{ marginBottom: '24px', textAlign: 'justify' }}>
        Pengguna memiliki hak untuk mengakses, memperbaiki, atau menghapus informasi pribadi mereka yang tersimpan di dalam aplikasi. Permintaan dapat diajukan melalui kontak yang tersedia di bawah.
      </p>

      <h2 style={{ 
        color: '#1890ff', 
        marginTop: '32px', 
        marginBottom: '16px',
        fontSize: '20px'
      }}>
        6. Perubahan Kebijakan Privasi
      </h2>
      <p style={{ marginBottom: '24px', textAlign: 'justify' }}>
        Kami dapat memperbarui Kebijakan Privasi ini dari waktu ke waktu. Kami akan memberi tahu pengguna melalui aplikasi atau media lain jika terdapat perubahan penting.
      </p>

      <h2 style={{ 
        color: '#1890ff', 
        marginTop: '32px', 
        marginBottom: '16px',
        fontSize: '20px'
      }}>
        7. Kontak
      </h2>
      <p style={{ marginBottom: '12px', textAlign: 'justify' }}>
        Jika Anda memiliki pertanyaan atau permintaan terkait kebijakan privasi ini, silakan hubungi kami di:
      </p>
      <p style={{ marginBottom: '8px' }}>
        Alamat: Jl. Kihajar Dewantara No.124, Sawah Lama, Kec. Ciputat, Kota Tangerang Selatan, Banten 15413
      </p>      
      <p style={{ marginBottom: '8px' }}>
        Email: <a href="mailto:bumibambini@gmail.com" style={{ color: '#1890ff' }}>bumibambini@gmail.com</a>
      </p>
      <p style={{ marginBottom: '0' }}>
        Telepon: 021 74714352
      </p>
    </div>
  );
}

export default Privacy;